import React, { Component } from "react";

class Right extends Component {
  render() {
    return (
      <aside>
        300x250
      </aside>
    );
  }
}

export default Right;
